import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { FAQSection } from '../components/FAQSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';

const Landing = () => {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-off-white)' }}>
      <Navigation />
      <HeroSection />
      <PainPointsSection />
      <ServicesSection />
      <ProcessSection />
      <AboutSection />
      <ProgramsSection />
      <FAQSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Landing;
